export class User {
    user_pk: number;
    created_at: string;
    ip: string;
    wg_name: string;

    constructor(row: Object) {
        this.user_pk = row['user_pk'];
        this.created_at = row['created_at'];
        this.ip = row['ip'];
        this.wg_name = row['wg_name'];
    }
}



// WEBPACK FOOTER //
// /home/jacobo/proyectos/venta-extranet/src/app/user/model/user.ts